/**
 * @author Shalling（张小玲）
 * @email shalling@staritgp.com
 * @date 2020-05-06 14:20
 */
import React from 'react'

type showPaymentPasswordModal = (
  paymentPasswordVisible: boolean,
  paymentPasswordSubtotal?: string | number,
  paymentPasswordLoading?: boolean,
  paymentPasswordOnSubmit?: (string) => void | undefined) => void

interface WithPaymentPasswordPropType {
  showPaymentPasswordModal: showPaymentPasswordModal
  paymentPasswordVisible: boolean
  paymentPasswordSubtotal?: string | number | undefined
  paymentPasswordLoading?: boolean | undefined
  paymentPasswordOnSubmit?: (string) => void | undefined | Promise<unknown>
}

const context = React.createContext({} as WithPaymentPasswordPropType)
const { Provider, Consumer } = context

export default Component => function withPaymentPassword (props) {
  return (
    <Consumer>
      {
        ({
          paymentPasswordVisible,
          paymentPasswordSubtotal,
          paymentPasswordLoading,
          paymentPasswordOnSubmit,
          showPaymentPasswordModal,
        }) => (
          <Component
            paymentPasswordVisible={paymentPasswordVisible}
            paymentPasswordSubtotal={paymentPasswordSubtotal}
            paymentPasswordLoading={paymentPasswordLoading}
            paymentPasswordOnSubmit={paymentPasswordOnSubmit}
            showPaymentPasswordModal={showPaymentPasswordModal}
            {...props}
          />
        )
      }
    </Consumer>
  )
}

export { Provider as PaymentPasswordProvider, context as PaymentPasswordContext, WithPaymentPasswordPropType }
